import qs from 'qs';
import { useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';

const STALE_TIME = 5 * 60 * 1000;

export const getStatistic = ({ metric, granularity, from, to }) =>
  axios.get(`/api/statistics?${qs.stringify({ metric, granularity, from, to })}`);

export const useStatistic = ({ metric, granularity, from, to }, config = {}) =>
  useQuery({
    queryKey: ['statistics', metric, granularity, from, to],
    queryFn: () => getStatistic({ metric, granularity, from, to }),
    select: ({ data }) => data,
    staleTime: STALE_TIME,
    retry: false,
    ...config,
  });
